(function () {
  function money(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }

    return '$' + (Number(cents || 0) / 100).toFixed(2);
  }

  function selectedOptions(root) {
    return Array.from(root.querySelectorAll('[data-simple-option-group]')).map(function (group) {
      var checked = group.querySelector('input:checked');
      return checked ? checked.value : '';
    });
  }

  function findVariant(variants, options) {
    return variants.find(function (variant) {
      return variant.options.every(function (option, index) {
        return option === options[index];
      });
    });
  }

  function firstSellingPlanAllocation(variant) {
    if (!variant || !variant.selling_plan_allocations || !variant.selling_plan_allocations.length) {
      return null;
    }

    return variant.selling_plan_allocations[0];
  }

  function selectedPurchaseType(root) {
    return (
      root.querySelector('input[name^="purchaseType-"]:checked') ||
      root.querySelector('input[name="simple_purchase_type"]:checked')
    );
  }

  function isSubscriptionPurchase(purchaseType) {
    if (!purchaseType) return false;

    return purchaseType.value === 'subscription' || purchaseType.value === 'purchaseTypeSubscription';
  }

  function selectedSellingPlanControl(root) {
    return (
      root.querySelector('input[name="stay-ai-selling-plan-selector"]:checked') ||
      root.querySelector('select[name="stay-ai-selling-plan-selector"]') ||
      root.querySelector('[data-simple-selling-plan-select]') ||
      root.querySelector('input[name="simple_selling_plan"]:checked')
    );
  }

  function discountPercent(comparePrice, price) {
    comparePrice = Number(comparePrice || 0);
    price = Number(price || 0);
    if (!comparePrice || price >= comparePrice) return 0;

    return Math.round(((comparePrice - price) / comparePrice) * 100);
  }

  function servingCount(variant, servingsPerBag) {
    var title = [variant && variant.title].concat(variant && variant.options ? variant.options : []).join(' ');
    var packMatch = title.match(/\b(3|6|12)\s*(pack)?\b/i);
    var packCount = packMatch ? Number(packMatch[1]) : 3;

    return Math.max(1, packCount * (servingsPerBag || 4));
  }

  function servingPrice(price, variant, servingsPerBag) {
    return '$' + (Number(price || 0) / 100 / servingCount(variant, servingsPerBag)).toFixed(2) + '/serving';
  }

  function visibleGalleryThumbs(root) {
    return Array.from(root.querySelectorAll('[data-simple-thumb]')).filter(function (thumb) {
      return !thumb.hidden;
    });
  }

  function scrollThumbIntoView(thumb) {
    if (!thumb || typeof thumb.scrollIntoView !== 'function') return;
    thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
  }

  function setMainImage(root, thumb) {
    var image = root.querySelector('[data-simple-main-image]');
    if (!image || !thumb) return;

    var src = thumb.getAttribute('data-src');
    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
    image.src = src;
    image.alt = thumb.getAttribute('data-alt') || image.alt;
    root.querySelectorAll('[data-simple-thumb]').forEach(function (item) {
      item.classList.toggle('is-active', item === thumb);
    });
    scrollThumbIntoView(thumb);
  }

  function moveGallery(root, direction) {
    var thumbs = visibleGalleryThumbs(root);
    if (thumbs.length < 2) return;

    var active = root.querySelector('[data-simple-thumb].is-active:not([hidden])');
    var activeIndex = thumbs.indexOf(active);
    if (activeIndex === -1) activeIndex = 0;

    var nextIndex = activeIndex + direction;
    if (nextIndex < 0 || nextIndex >= thumbs.length) return;
    setMainImage(root, thumbs[nextIndex]);
  }

  function wireGallerySwipe(root) {
    var target = root.querySelector('.simple-pdp__main-image') || root.querySelector('[data-simple-gallery-track]');
    if (!target || target.dataset.simpleGallerySwipeReady === 'true') return;
    target.dataset.simpleGallerySwipeReady = 'true';

    var startX = 0;
    var startY = 0;
    var startTime = 0;

    target.addEventListener(
      'touchstart',
      function (event) {
        if (!event.touches || event.touches.length !== 1) return;
        startX = event.touches[0].clientX;
        startY = event.touches[0].clientY;
        startTime = Date.now();
      },
      { passive: true }
    );

    target.addEventListener(
      'touchend',
      function (event) {
        if (!event.changedTouches || event.changedTouches.length !== 1) return;

        var deltaX = event.changedTouches[0].clientX - startX;
        var deltaY = event.changedTouches[0].clientY - startY;
        var elapsed = Date.now() - startTime;
        if (elapsed > 700 || Math.abs(deltaX) < 45 || Math.abs(deltaX) < Math.abs(deltaY) * 1.4) return;

        moveGallery(root, deltaX < 0 ? 1 : -1);
      },
      { passive: true }
    );
  }

  function updateGallery(root, variant) {
    var thumbs = Array.from(root.querySelectorAll('[data-simple-thumb]'));
    if (!thumbs.length || !variant) return;

    var variantId = String(variant.id);
    var visibleThumbs = [];

    thumbs.forEach(function (thumb) {
      var variantIds = (thumb.getAttribute('data-variant-ids') || '').split(',').filter(Boolean);
      var isVisible = !variantIds.length || variantIds.indexOf(variantId) !== -1;
      thumb.hidden = !isVisible;
      if (isVisible) visibleThumbs.push(thumb);
    });

    var currentActive = root.querySelector('[data-simple-thumb].is-active:not([hidden])');
    if (currentActive) return;

    var variantImageId = variant.featured_image && variant.featured_image.id ? String(variant.featured_image.id) : '';
    var variantThumb = variantImageId
      ? visibleThumbs.find(function (thumb) {
          return thumb.getAttribute('data-image-id') === variantImageId;
        })
      : null;

    setMainImage(root, variantThumb || visibleThumbs[0]);
  }

  function update(root) {
    var servingsPerBag = Number(root.getAttribute('data-simple-servings-per-bag')) || 4;
    var variants = JSON.parse(root.querySelector('[data-simple-variants]').textContent);
    var variant = findVariant(variants, selectedOptions(root)) || variants[0];
    var purchaseType = selectedPurchaseType(root);
    var sellingPlanInput = root.querySelector('[name="selling_plan"]');
    var variantInput = root.querySelector('[name="id"]');
    var submitButtons = root.querySelectorAll('[data-simple-submit]');
    var priceTargets = root.querySelectorAll('[data-simple-price]');
    var oneTimePriceTargets = root.querySelectorAll('[data-simple-one-time-price]');
    var compareTargets = root.querySelectorAll('[data-simple-compare-price]');
    var subscriptionPriceTargets = root.querySelectorAll('[data-simple-subscription-price]');
    var subscriptionCompareTargets = root.querySelectorAll('[data-simple-subscription-compare]');
    var subscriptionBadgeTargets = root.querySelectorAll('[data-simple-subscription-badge]');
    var subscriptionServingTargets = root.querySelectorAll('[data-simple-subscription-serving]');
    var oneTimeServingTargets = root.querySelectorAll('[data-simple-one-time-serving]');
    var subscriptionDiscountTargets = root.querySelectorAll('[data-simple-subscription-discount]');
    var optionMetaTargets = root.querySelectorAll('[data-simple-option-meta]');
    var stickyTitle = root.querySelector('[data-simple-sticky-title]');
    var selectedAllocation = null;

    if (isSubscriptionPurchase(purchaseType)) {
      var planInput = selectedSellingPlanControl(root);
      if (planInput && variant.selling_plan_allocations) {
        selectedAllocation = variant.selling_plan_allocations.find(function (allocation) {
          return String(allocation.selling_plan_id) === String(planInput.value);
        });
      }
      selectedAllocation = selectedAllocation || firstSellingPlanAllocation(variant);
    }

    if (variantInput) variantInput.value = variant.id;
    if (sellingPlanInput) {
      sellingPlanInput.value = selectedAllocation ? selectedAllocation.selling_plan_id : '';
      sellingPlanInput.disabled = !selectedAllocation;
    }

    var displayPrice = selectedAllocation ? selectedAllocation.price : variant.price;
    var subscriptionComparePrice =
      variant.compare_at_price && variant.compare_at_price > variant.price ? variant.compare_at_price : variant.price;
    priceTargets.forEach(function (target) {
      target.textContent = money(displayPrice);
    });
    oneTimePriceTargets.forEach(function (target) {
      target.textContent = money(variant.price);
    });

    var firstAllocation = firstSellingPlanAllocation(variant);
    var firstAllocationDiscount = firstAllocation ? discountPercent(subscriptionComparePrice, firstAllocation.price) : 0;
    subscriptionPriceTargets.forEach(function (target) {
      target.textContent = money(firstAllocation ? firstAllocation.price : variant.price);
    });

    subscriptionCompareTargets.forEach(function (target) {
      target.textContent = money(subscriptionComparePrice);
      target.hidden = !firstAllocation || firstAllocation.price >= subscriptionComparePrice;
      target.style.display = target.hidden ? 'none' : '';
    });

    subscriptionBadgeTargets.forEach(function (target) {
      target.textContent = firstAllocationDiscount + '% Off';
      target.hidden = !firstAllocationDiscount;
    });

    subscriptionServingTargets.forEach(function (target) {
      target.textContent = servingPrice(firstAllocation ? firstAllocation.price : variant.price, variant, servingsPerBag);
      target.hidden = !firstAllocation;
    });

    oneTimeServingTargets.forEach(function (target) {
      target.textContent = servingPrice(variant.price, variant, servingsPerBag);
    });

    subscriptionDiscountTargets.forEach(function (target) {
      target.textContent = firstAllocationDiscount + '% Off';
    });

    optionMetaTargets.forEach(function (target) {
      var optionInput = target.closest('label') && target.closest('label').querySelector('input[type="radio"]');
      var optionVariant = optionInput
        ? variants.find(function (item) {
            return item.options.indexOf(optionInput.value) !== -1;
          })
        : null;
      optionVariant = optionVariant || variant;

      var optionComparePrice =
        optionVariant.compare_at_price && optionVariant.compare_at_price > optionVariant.price
          ? optionVariant.compare_at_price
          : optionVariant.price;
      var optionAllocation = firstSellingPlanAllocation(optionVariant);
      var oneTimeDiscount = discountPercent(optionComparePrice, optionVariant.price);
      var subscriptionDiscount = optionAllocation
        ? discountPercent(optionComparePrice, optionAllocation.price)
        : oneTimeDiscount;
      var packTitle = [optionVariant.title].concat(optionVariant.options || []).join(' ');
      var isThreePack = /\b3\s*(pack)?\b/i.test(packTitle);
      var oneTimeText = oneTimeDiscount + '% off' + (isThreePack ? '' : ' + free shipping');
      var subscriptionText = subscriptionDiscount + '% off + free shipping';

      target.setAttribute('data-simple-one-time-meta', oneTimeText);
      target.setAttribute('data-simple-subscription-meta', subscriptionText);
      target.textContent = isSubscriptionPurchase(purchaseType) ? subscriptionText : oneTimeText;
    });

    if (root.getAttribute('data-product-handle') !== 'gnocchi-pro') {
    // Keep ordinary 3-pack claims tied to the actual variant allocation.
    var threePackSelected = /\b3\s*pack\b/i.test(String(variant.title || ''));
    var threePackReference = Math.max(Number(variant.compare_at_price || 0), Number(variant.price || 0));
    var laterAdjustments = firstAllocation && firstAllocation.price_adjustments || [];
    var laterAdjustment = laterAdjustments.find(function (item) { return Number(item.position) === 2; }) || laterAdjustments[laterAdjustments.length - 1];
    var laterPrice = laterAdjustment && Number(laterAdjustment.price);
    var threePackRenewal = threePackSelected && laterPrice ? discountPercent(threePackReference, laterPrice) : 0;
    if (threePackSelected) {
      root.querySelectorAll('[data-simple-subscription-discount]').forEach(function (target) {
        target.textContent = threePackRenewal ? threePackRenewal + '% Off' : '';
      });
      root.querySelectorAll('[data-simple-subscription-discount-value]').forEach(function (target) {
        target.textContent = firstAllocationDiscount + '%';
      });
    }
    root.querySelectorAll('[data-simple-subscription-renewal-discount]').forEach(function (target) {
      var previous = target.getAttribute('data-other-pack-renewal-discount') || '20';
      target.textContent = (threePackSelected ? threePackRenewal : previous) + '%';
    });
    root.querySelectorAll('[data-simple-subscription-savings]').forEach(function (target) {
      target.hidden = threePackSelected && (!firstAllocationDiscount || !threePackRenewal);
    });
    root.querySelectorAll('[data-simple-subscription-timing]').forEach(function (target) {
      if (threePackSelected) {
        target.textContent = threePackRenewal
          ? 'Save ' + firstAllocationDiscount + '% today and ' + threePackRenewal + '% after the first month'
          : 'Save ' + firstAllocationDiscount + '% today';
      } else {
        target.textContent = target.getAttribute('data-other-pack-text') || '';
      }
      target.hidden = false;
      target.style.display = '';
    });
    root.querySelectorAll('[data-simple-one-time-discount]').forEach(function (target) {
      if (threePackSelected) {
        var discount = discountPercent(threePackReference, variant.price);
        target.textContent = discount + '%';
        if (target.parentElement) {
          target.parentElement.hidden = !discount;
          target.parentElement.style.display = discount ? '' : 'none';
        }
      } else if (target.parentElement) {
        target.parentElement.hidden = false;
        target.parentElement.style.display = '';
      }
    });
    root.querySelectorAll('[data-simple-option-group] label.simple-pdp__option').forEach(function (label) {
      var optionInput = label.querySelector('input[type="radio"]');
      if (!optionInput || !/\b3\s*pack\b/i.test(optionInput.value)) return;
      var optionVariant = variants.find(function (item) { return item.options.indexOf(optionInput.value) !== -1; });
      if (!optionVariant) return;
      var reference = Math.max(Number(optionVariant.compare_at_price || 0), Number(optionVariant.price || 0));
      var allocation = firstSellingPlanAllocation(optionVariant);
      var subscribed = isSubscriptionPurchase(purchaseType) && allocation;
      var price = subscribed ? Number(allocation.price) : Number(optionVariant.price);
      var percent = discountPercent(reference, price);
      var meta = label.querySelector('[data-simple-option-meta]');
      if (meta) {
        var template = meta.getAttribute(subscribed ? 'data-simple-subscription-meta' : 'data-simple-one-time-meta') || meta.textContent || '';
        meta.textContent = percent ? (/\d+\s*%/.test(template) ? template.replace(/\d+\s*%/, percent + '%') : percent + '% off') : '';
        meta.hidden = !percent;
        meta.style.display = percent ? '' : 'none';
      }
      var savings = label.querySelector('[data-simple-option-savings]');
      if (savings) {
        var cents = Math.max(0, reference - price);
        savings.textContent = cents ? 'Save ' + money(cents) : '';
        savings.hidden = !cents;
        savings.style.display = cents ? '' : 'none';
      }
    });

    }
    compareTargets.forEach(function (target) {
      var comparisonPrice = target.closest('[data-simple-one-time-purchase]') ? variant.price : displayPrice;
      if (variant.compare_at_price && variant.compare_at_price > comparisonPrice) {
        target.textContent = money(variant.compare_at_price);
        target.hidden = false;
        target.style.display = '';
      } else {
        target.hidden = true;
        target.style.display = 'none';
      }
    });

    if (stickyTitle) {
      stickyTitle.textContent = root.getAttribute('data-product-title') + ' - ' + money(displayPrice);
    }

    submitButtons.forEach(function (button) {
      button.disabled = !variant.available;
      var submitText = button.querySelector('[data-simple-submit-text]');
      if (submitText) {
        submitText.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
      }
    });

    updateGallery(root, variant);
  }

  var prefetchedShapeUrls = {};

  function prefetchShapeUrl(url) {
    return;
    if (!url || prefetchedShapeUrls[url]) return;

    var link = document.createElement('link');
    link.rel = 'prefetch';
    link.href = url;
    link.as = 'document';
    document.head.appendChild(link);
    prefetchedShapeUrls[url] = true;
  }

  function queueShapePrefetch(url) {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(function () {
        prefetchShapeUrl(url);
      });
      return;
    }

    window.setTimeout(function () {
      prefetchShapeUrl(url);
    }, 900);
  }

  function enhanceShapeNavigation(root) {
    root.querySelectorAll('[data-simple-shape-link]').forEach(function (link) {
      var url = link.getAttribute('data-simple-prefetch-url') || link.href;

      queueShapePrefetch(url);
      link.addEventListener('mouseenter', function () {
        prefetchShapeUrl(url);
      });
      link.addEventListener(
        'touchstart',
        function () {
          prefetchShapeUrl(url);
        },
        { passive: true }
      );

      link.addEventListener('click', function () {
        if (link.classList.contains('is-active')) return;

        root.classList.add('is-shape-loading');
        link.classList.add('is-loading');
        link.setAttribute('aria-busy', 'true');
      });
    });
  }

  document.querySelectorAll('[data-simple-pdp]').forEach(function (root) {
    if (root.dataset.simplePdpReady === 'true') return;
    root.dataset.simplePdpReady = 'true';

    var form = root.querySelector('[data-simple-form]');

    root.addEventListener('change', function () {
      update(root);
    });

    if (form) {
      form.addEventListener('submit', function (event) {
        if (typeof window.addToCartHandler !== 'function') return;

        event.preventDefault();
        if (form.dataset.simpleSubmitting === 'true') return;

        form.dataset.simpleSubmitting = 'true';
        window.addToCartHandler(form);
        window.setTimeout(function () {
          form.dataset.simpleSubmitting = 'false';
        }, 1200);
      });
    }

    root.querySelectorAll('[data-simple-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        setMainImage(root, thumb);
      });
    });

    wireGallerySwipe(root);

    root.querySelectorAll('[data-simple-submit]').forEach(function (button) {
      button.addEventListener('click', function () {
        if (button.type === 'submit') return;
        root.querySelector('[data-simple-form]').requestSubmit();
      });
    });

    enhanceShapeNavigation(root);
    update(root);
  });

  document.querySelectorAll('[data-simple-testimonials]').forEach(function (root) {
    if (root.dataset.simpleTestimonialsReady === 'true') return;
    root.dataset.simpleTestimonialsReady = 'true';

    var track = root.querySelector('[data-simple-testimonial-track]');
    var slides = Array.from(root.querySelectorAll('.simple-pdp__testimonial-slide'));
    var dots = Array.from(root.querySelectorAll('[data-simple-testimonial-dot]'));
    var prev = root.querySelector('[data-simple-testimonial-prev]');
    var next = root.querySelector('[data-simple-testimonial-next]');
    var autoplayDelay = 4500;
    var autoplayTimer = null;
    if (!track || !slides.length) return;

    function currentIndex() {
      var width = track.clientWidth || 1;
      return Math.round(track.scrollLeft / width);
    }

    function setActive(index) {
      dots.forEach(function (dot, dotIndex) {
        dot.classList.toggle('is-active', dotIndex === index);
      });
    }

    function go(index) {
      var nextIndex = (index + slides.length) % slides.length;
      track.scrollTo({ left: nextIndex * track.clientWidth, behavior: 'smooth' });
      setActive(nextIndex);
    }

    function startAutoplay() {
      if (slides.length < 2) return;
      window.clearInterval(autoplayTimer);
      autoplayTimer = window.setInterval(function () {
        go(currentIndex() + 1);
      }, autoplayDelay);
    }

    function restartAutoplay() {
      startAutoplay();
    }

    if (prev) {
      prev.addEventListener('click', function () {
        go(currentIndex() - 1);
        restartAutoplay();
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        go(currentIndex() + 1);
        restartAutoplay();
      });
    }

    dots.forEach(function (dot, index) {
      dot.addEventListener('click', function () {
        go(index);
        restartAutoplay();
      });
    });

    track.addEventListener('scroll', function () {
      window.requestAnimationFrame(function () {
        setActive(currentIndex());
      });
    });

    startAutoplay();
  });
})();
